import { memo } from 'react';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import ComponentWrapper from '../../common/ContentWrapper';
import { REGIONS } from '../../../core/japaneseRegions';
import Link from '../../common/Link/Link';
import testIds from './testIds';

const PrefecturesList = ({ searchQuery }: { searchQuery: string }) => {
  const { t } = useTranslation('home');

  return (
    <ComponentWrapper className="pb-14 sm:pb-20">
      <h2 className="app-section-title">{t('search_by_region.search_by_region_title')}</h2>

      <div className="flex flex-row flex-wrap">
        {REGIONS.map((region) => (
          <>
            <span
              key={region.name}
              className="mr-5 text-small"
              data-testid={`${testIds.regionItem}`}
            >
              <b>
                <Link
                  key={region.name}
                  href={`/search/region/${region.path}?${searchQuery}`}
                  prefetch={false}
                >
                  <a className="text-gray-600 hover:underline">{t(region.name)}</a>
                </Link>
              </b>
            </span>
            <span className="mr-3 text-gray-200">|</span>
            {region.prefectures.map((prefecture, index) => (
              <span
                key={prefecture.path}
                className={classNames('text-small', {
                  'mr-4': index + 1 === region.prefectures.length,
                })}
                data-testid={`${testIds.prefectureListItem}`}
              >
                <Link
                  href={`/search/prefecture/${prefecture.path}?${searchQuery}`}
                  prefetch={false}
                >
                  <a className="mr-3 text-gray-600 hover:underline">{t(prefecture.name)}</a>
                </Link>
              </span>
            ))}
          </>
        ))}
      </div>
    </ComponentWrapper>
  );
};

export default memo(PrefecturesList);
